import { Component, OnInit, Inject } from '@angular/core';
import { Router  } from '@angular/router';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';


import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { MiscService } from 'src/app/_service/misc.service';
declare var $: any;
@Component({
  selector: 'app-ipd-transaction',
  templateUrl: './ipd-transaction.component.html',
  styleUrls: ['./ipd-transaction.component.css']
})
export class IpdTransactionComponent implements OnInit {
  placements = ['left'];
  popoverTitle = 'Are you sure?';
  popoverMessage = 'Are you really <b>sure</b> you want to do this?';
  confirmText = 'Yes <i class="fas fa-check"></i>';
  cancelText = 'No <i class="fas fa-times"></i>';
  confirmClicked = false;
  cancelClicked = false;
  IpdForm: FormGroup;loading:boolean=false;submitted:boolean=false;dataLoaded:boolean=false;uploading:boolean=false;resourseNameList=[]; resourcesTotal=0;disableSelect:any = [];
  myrole:string='';IpdChk:boolean=false; IpdDetails:any;IPDsurgDate:any;ShareData=[];glamyoShare=0;ipdId:any; IpdResCheck:boolean=false;glamyoLoss:boolean=false;vendorNameList:any=[];vendorNameList_copy:any=[];is_doctor_access:string; isReadOnly = false;
  constructor(public dialogRef: MatDialogRef<IpdTransactionComponent>,@Inject(MAT_DIALOG_DATA) public data: MatDialog,
  private router:Router,private sharedapi:SharedService, private leadapi:LeadsService,private formBuilder: FormBuilder,private miscapi:MiscService) 
  {
     this.IpdForm = this.formBuilder.group({ 
          'settled_amt' : [null],
          'billed_amt' : [null],
          'doctor_name' : [null],
          'hospital_name' : [null],
          'user_name' : [null],
          'payment_mode' : [null],
          'hospital_share':[null,Validators.required],
          'doctor_share':[null,Validators.required],
          'glamyo_share':[null],
          'ipdResources': this.formBuilder.array([]) ,
      });
      
  }

  

  ngOnInit(): void 
  {
      this.getIpdDetails();
      this.sharedapi.getRole()
      .subscribe((item:string) => {this.myrole=item;});
      this.myrole = localStorage.getItem('role');
      this.getVendorData();
      this.is_doctor_access = localStorage.getItem('is_doctor_access');
      if(this.myrole=='4' && this.is_doctor_access=='1'){
        this.isReadOnly = true;
      }

  }


  get f() { return this.IpdForm.controls; }

  

  getIpdDetails()
  {
      this.dataLoaded = false;
      this.leadapi.getIpdDetails(this.data).subscribe(
      (data:any) => {
          this.dataLoaded = true;
          
          if(data && data.status)
          {
              this.IpdDetails=data.data;
              //this.getHospital_DoctorShare();
              this.fetchUsedResourceData();
              this.IPDsurgDate= new Date(data.data.surgery_date*1000).toLocaleString();
              this.IpdForm.controls['settled_amt'].setValue(data.data.settled_amt);
              this.IpdForm.controls['billed_amt'].setValue(data.data.billed_amt);
              this.IpdForm.controls['doctor_name'].setValue(data.data.doctorName);
              this.IpdForm.controls['hospital_name'].setValue(data.data.hospitalName);
              this.IpdForm.controls['payment_mode'].setValue(data.data.payment_mode);
              this.IpdForm.controls['user_name'].setValue(data.data.bd_name);
              if(data.data.hospital_share){
                this.IpdForm.controls['hospital_share'].setValue(data.data.hospital_share);
              }else{
                this.IpdForm.controls['hospital_share'].setValue(0);
              }

              if(data.data.doctor_share){
                this.IpdForm.controls['doctor_share'].setValue(data.data.doctor_share);
              }else{
                this.IpdForm.controls['doctor_share'].setValue(0);
              }
              this.IpdForm.controls['glamyo_share'].setValue(data.data.glamyo_share);
              this.calculate_glamyoShare();
              
          }else{
              if(data.error_type!='no')
              this.sharedapi.presentToast('Error Occured');
          }
      },
      error => {
          this.sharedapi.checkError(error);
      });
  }

  CloseModal(): void {
      this.dialogRef.close();
  }
  
  async fetchUsedResourceData()
  {
      this.leadapi.fetchUsedResource(this.data['ipd_id']).subscribe((data:any) => {
          if(data.status)
          {
            let tempData=data.data;
            let controlArray = this.IpdForm.get('ipdResources') as FormArray;
            controlArray.clear();
            data.data.forEach((element, index) => {
              if(element.id){
                this.IpdResCheck=true;
              }else{
                this.IpdResCheck=false;
              }
              this.GetResourcesData(element.consumable_type,index);
                controlArray.push(this.formBuilder.group({
                  resourceType: element.consumable_type,
                  resourceName: element.consumable_id,
                  resourcePrice: element.consumable_price,
                  resourceId :element.id,
                  vendor_id:element.vendor_id,
                }));
                this.calculate_glamyoShare();
               
            });
          }else{
            
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }
  
  async getHospital_DoctorShare()
  {
      let data={
        treatment_id:this.IpdDetails.treatment_id,
        doctor_id:this.IpdDetails.doctor_id,
        hospital_id:this.IpdDetails.hospital_id 
      }
      this.leadapi.getHDShares(data).subscribe((data:any) => {
          if(data.status)
          {
            this.ShareData= data.data;
            this.IpdForm.controls['hospital_share'].setValue(this.ShareData[0].hospitalshare);
            this.IpdForm.controls['doctor_share'].setValue(this.ShareData[0].doctorshare);
            this.calculate_glamyoShare();
          }else{
            this.ShareData=[]; 
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  calculate_glamyoShare(){
    let controlArray = <FormArray>this.IpdForm.controls["ipdResources"];
    var totalamt=0;
    if(controlArray.value.length){
        controlArray.value.forEach(element => {
        totalamt+=parseInt(element.resourcePrice);
        this.resourcesTotal=totalamt;
      }); 
    }else{
      this.resourcesTotal=0;
    }
    var ResourceAmt=0;
    if(this.resourcesTotal){
      ResourceAmt=this.resourcesTotal;
    }else{
      ResourceAmt=0;
    }
    let billed_amt= this.IpdForm.get('settled_amt').value;
    
    let hospitalShare= this.IpdForm.get('hospital_share').value;
    if(hospitalShare){
      hospitalShare=hospitalShare;
    }else{
      hospitalShare=0
    }
    let doctorShare= this.IpdForm.get('doctor_share').value;
    if(doctorShare){
      doctorShare=doctorShare;
    }else{
      doctorShare=0
    }
    this.glamyoShare=parseInt(billed_amt) - (parseInt(hospitalShare) + parseInt(doctorShare) + ResourceAmt);
    this.IpdForm.controls['glamyo_share'].setValue(this.glamyoShare);
    if(this.glamyoShare >= 0){
      this.glamyoLoss=false;
    }else{
      this.glamyoLoss=true;
    }
  }

  async SubmitData(){
    this.loading = true;
    this.submitted = true;
    if (this.IpdForm.invalid) {
      this.loading = false;
      return;
    }
    this.IpdForm.value.ipd_id= parseInt(this.data['ipd_id']);
    this.IpdForm.value.treatment_id= parseInt(this.data['treatment_id']); 
    this.leadapi.IpdUsedResource(this.IpdForm.value)
    .subscribe((data:any) => {
        this.submitted = false;
        this.loading = false;
        if(data.status)
        {

          if(this.IpdResCheck){
            this.sharedapi.presentToast('Data Updated Successfully');
          }else{
            this.sharedapi.presentToast('Data Added Successfully');
          }
          
          setTimeout(() => {
            this.CloseModal();
          }, 4000);
          
          this.router.navigateByUrl('/ipds');
        }
        else
        {
            this.sharedapi.presentToast(data.msg);
        }
      }, error => 
        {
            this.sharedapi.checkError(error);
    });
  }

  async GetResourcesData(id,index){
      this.leadapi.getIpdResourcesList(id).subscribe((data:any) => {
      if(data.status)
      {
        this.resourseNameList[index]=data.data;
      }else{
        this.resourseNameList=[];
      }
    }, error => {
          this.sharedapi.checkError(error);
      });
  }

  
  ipdResources() : FormArray {
    return this.IpdForm.get("ipdResources") as FormArray
  }

  newQuantity(): FormGroup 
  {
    return this.formBuilder.group({
      resourceType: '',
      resourceName: '',
      resourcePrice: '',
      resourceId:'',
      vendor_id:''
    })
    
  }

   
  addQuantity() {
      this.ipdResources().push(this.newQuantity());
      let getIndex= this.IpdForm.controls["ipdResources"].value.length-1;
      this.disableSelect[getIndex]=true;
  }
   
  removeQuantity(i:number) {
    this.ipdResources().removeAt(i);
    this.calculate_glamyoShare();
  }

  PatchPriceData(index,obj){
    let controlArray = <FormArray>this.IpdForm.controls["ipdResources"];
    controlArray.controls[index].patchValue({
        resourcePrice: obj.price
    });
    this.disableSelect[index]=false;
    var totalamt=0;
    controlArray.value.forEach(element => {
        totalamt+=element.resourcePrice;
        this.resourcesTotal=totalamt;
    });  
    this.calculate_glamyoShare();
  }

  async getVendorData(){
    this.miscapi.getVendorList().subscribe((data:any) => {
    if(data.status)
    {
      this.vendorNameList=data.data;
      this.vendorNameList_copy = this.vendorNameList;
    }else{
      this.vendorNameList=[];
    }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  setSearchValue(type){
    if(type =='vendor'){
      $("#vendorSearch").val('');
      $("#vendorSearch").focus();
      this.vendorNameList= this.vendorNameList_copy;
    }
  }

  searchOnSelect(searchtText: string, type){
    if (type == 'vendor') {
      this.vendorNameList = this.sharedapi.searchData(searchtText, this.vendorNameList_copy, "vendor_name");
    }
  }
}